import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import { find, isEmpty } from 'lodash';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk/format';

import ListView from '../../../../../src/components/common/list-view';
import Text, { H3 } from '@dbk/ui-text';
import TouchableListItem from '../../../../../src/components/common/touchable-list-item';
import maskPortfolio from '../../../../../src/utils/mask-portfolio';
import { PALETTE } from '../../constants';
import { PAYMENT_DATE_TYPE, ROUTES, PENDING_YOUR_APPROVAL, FILTER_MULTISIG_NOTIFICATION, MULTISIGN_TAB_SELECT, FILTER_MULTISIG_PENDING_NOTIFICATION  } from '../../../../../src/constants'
import { PAYMENT_RANGE_ONE_WEEK } from '../../../../../src/screens/payments/constant'
import { today, weekAgo, monthAgo, formatToISODate, formatDateShortMonth } from '../../../../../src/utils/date';
import {
 getPaymentStatusList,
 getArrayForInitiator
} from './utils';

const MATURITY_7DAYS = 'maturities.7days';
const REPORTS = 'reports';
const MULTI_SIGN = 'MULTISIG'

class NotificationModal extends PureComponent {
  constructor() {
    super();
    this.state = {
      modalIsOpen: true,
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.handlePress = this.handlePress.bind(this);
    this.renderNotificationItemDetail = this.renderNotificationItemDetail.bind(this);
    this.getMulsiSigFilterOptionObj = this.getMultiSigFilterOptionObj.bind(this);
    this.isMultiSign = this.isMultiSign.bind(this);
  }

  // componentDidMount() {
  //   this.openModal();
  // }
  // componentWillUnmount() {
  //   this.closeModal();
  // }


  openModal() {
    this.setState({ modalIsOpen: true });
  }
  afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

//  
// Function for setting filter object
  getMultiSigFilterOptionObj(detail) {
    const paymentList = getPaymentStatusList(detail.key)
    let currentUserId = this.props.auth.userId
    const initiatorArr = getArrayForInitiator(detail.key , currentUserId)
    let obj = {}
    if (detail.key === PENDING_YOUR_APPROVAL.KEY) {
      obj = {
        selectedExecDate: '',
        selectedDate: PAYMENT_DATE_TYPE.EXECUTION_DATE,
        paymentStatusList: paymentList,
        filters: FILTER_MULTISIG_PENDING_NOTIFICATION
      }
    }
    else {
      obj = {
        selectedExecDate: PAYMENT_RANGE_ONE_WEEK,
        selectedDate: PAYMENT_DATE_TYPE.CONCLUSION_DATE,
        paymentStatusList: paymentList,
        conclusionFromDate: weekAgo,
        conclusionToDate: today,
        filters: FILTER_MULTISIG_NOTIFICATION,
        initiatorList: initiatorArr
      }
    }
    return obj;
  }

  closeModal() {
    const { notifications: { markedAsRead }, auth: { isNotificationDisabledForRM } } = this.props;

    if (!isNotificationDisabledForRM) {
      markedAsRead();
    }
    // this.setState({ modalIsOpen: false });
    this.props.onChange();
  }
  isMultiSign(type) {
    if (type === MULTI_SIGN) {
      return true
    }
    return false
  }

  handlePress(type, detail) {
    const {
      changePage,
      rsaChangePage,
      rsa: { rsaAuthorised },
      app: {
        user: {
          selectedPortfolioId,
          portfoliosData,
          setSelectedPortfolioId,
          setSelectedPortfolioData,
        },
      },
      onDone,
    } = this.props;

    let pagename, isRoot;
    if (detail) {
      switch (type) {
        case MATURITY_7DAYS:
          pagename = '/maturities';
          isRoot = true;
          break;
        case REPORTS:
          pagename = '/reports';
          isRoot = true;
          break;
        default:
          break;
      }
      const portfolioData = find(portfoliosData, { id: detail.portfolioId });

      if (detail.portfolioId !== selectedPortfolioId && portfolioData != null) {
        setSelectedPortfolioId(detail.portfolioId);
        setSelectedPortfolioData(portfolioData);
      }
    }

    if (type === 'reports') {
      pagename = '/reports';
      isRoot = true;
      this.props.reports.setOpenDateRangeTab(true);
    }

    if (this.isMultiSign(type)) {
      pagename = ROUTES.PAYMENT.DASHBOARD;
      isRoot = true;
      this.props.payments.setTabSelectedForMultiUser(MULTISIGN_TAB_SELECT.MULTISIG_APPROVALS);
      let objOptions = {};
      let userId = this.props.auth.userId
      this.props.payments.setFilterOptions(objOptions);
      if (detail) {
        objOptions = this.getMultiSigFilterOptionObj(detail);
        const filterParam = {
          paymentStatusList: [detail.key],
          conclusionFromDate: weekAgo,
          conclusionToDate: today,
          initiatorList: [userId]
        }
        if (detail.key === PENDING_YOUR_APPROVAL.KEY) { //WMCE-55290
          this.props.payments.applyMultiSignFilter({ paymentStatusList: [detail.key] });
        }
        else {
          this.props.payments.applyMultiSignFilter(filterParam);
        }
        this.props.payments.setFilterOptions(objOptions);
      }
      else {
        this.props.payments.getPaymentHistory('refetch'); //WMCE-55289- For getting refreshed payment list 
      }
    }

    if (pagename != null) {
      this.closeModal();
      rsaChangePage(pagename, isRoot);
    }
  }

  renderNotificationItemDetail(item, detail, description) {
    return (
      <TouchableListItem
        // onClick={this.props.auth.isNotificationDisabledForRM ? '' : () => this.handlePress(item.type, detail)}
        onClick={() => this.handlePress(item.type, detail)}
        key={this.isMultiSign(item.type)? `${item.type}-${detail.name}` : `${item.type}-${detail.portfolioId}`}
        hideArrow
      >
        <div className="notificationDetails pointer padding-top-10">
          <Text tertiary>{description}</Text>
        </div>
      </TouchableListItem>
    );
  }

  renderContent(row) {
    const { type, count } = row;
    const { rsa: { rsaAuthorised }, i18n: { messages } } = this.props;
    let title, description, detailComponent;

    switch (type) {
      case MATURITY_7DAYS:
        title = messages['app.profile.notification.maturity'];
        description =
          messages['app.notification.title'] +
          ' ' +
          count +
          ' ' +
          messages['app.notification.upcomingMat'];
        detailComponent = row.details.map((dtl) =>
          this.renderNotificationItemDetail(
            row,
            dtl,
            <FormattedMessage
              id={`app.notifications.items.details.maturityDescription`}
              values={{
                n: dtl.count,
                portfolioTitle: dtl.portfolioTitle,
              }}
            >
              {
                detailTxt => <Text tertiary> {detailTxt} </Text>
              }
            </FormattedMessage>
          )
        );
        break;

      case REPORTS:
        title = messages['app.profile.notification.Statement'];
        description =
          messages['app.notification.title'] +
          ' ' +
          count +
          ' ' +
          messages['app.notification.reportCount'];

        detailComponent = row.detailsch.map((categoryItem) =>

          this.renderNotificationItemDetail(
            row,
            categoryItem,
            <FormattedMessage
              id={`app.notifications.items.details.reportDescription`}
              values={{
                count: categoryItem.count,
                catName: categoryItem.catName
              }}
            >
              {
                detailTxt => <Text tertiary> {detailTxt} </Text>
              }
            </FormattedMessage>
          )
        );
        break;

      case MULTI_SIGN:
        title = messages['app.payments.multisig.rejectStatusModalTitle'];
        description =
          (<FormattedMessage
            id={`app.payments.multisig.notificationDescription`}
            values={{
              count: row.totalCount
            }}
          >
            {
              detailTxt => <Text secondary> {detailTxt} </Text>
            }
          </FormattedMessage>)

        const filteredList = row.notificationCategoryCountDtls.filter((categoryItem) => categoryItem.count > 0);
        detailComponent = filteredList.map((categoryItem) =>
          this.renderNotificationItemDetail(
            row,
            categoryItem,
            <FormattedMessage
              id={`app.notifications.items.details.${categoryItem.name}Description`}
              values={{
                count: categoryItem.count,
                catName: categoryItem.name
              }}
            >
              {
                detailTxt => <Text tertiary> {detailTxt} </Text>
              }
            </FormattedMessage>
          )
        ); ''
        break;
    }

    if (title == null) return null;
    if (row.totalCount === 0 && this.isMultiSign(type)) return null
    return (
      <div>
        <div className="notification-title">{title}</div>
        <Text
          onClick={() => this.handlePress(type)}
          secondary
          className={type === 'reports' || this.isMultiSign(type) ? 'pointer' : null}
        >
          {description}
        </Text>
        <div>{detailComponent}</div>
      </div>
    );
  }

  render() {
    const {
      screen,
      notifications: { userNotifications },
      i18n: { messages },
      marque: { loginDissmiss },
    } = this.props;
    const rowMarkerStyle = { fill: 'transparent' };

    const { height, width } = screen;
    const customStyles = {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 11,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      },
      content: {
        position: 'absolute',
        top: loginDissmiss ? '49px' : '90px',
        left: width > 570 ? 'auto' : 40,
        right: '55px',
        bottom: 'auto',
        padding: 0,
        border: 0,
        // WebkitOverflowScrolling    : 'touch',
        width: width > 640 ? '450px' : width - 80 + 'px',
        maxWidth: '450px',
        backgroundColor: 'transparent',
        overflow: 'visible',
      },
    };
    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.closeModal}
        style={customStyles}
        contentLabel="Modal"
        testID="blur-modal"
        ariaHideApp={false}
      >
        <View className="db-modal notificationModal">
          <View className="noti-modal">
            <View className="noti-modal-before" style={{ 'borderBottomColor': PALETTE.dbModalBackground }} />
            {userNotifications === null || userNotifications === undefined ||
              isEmpty(userNotifications.notifications) ||
              userNotifications.totalDisplay === 0 ? (
              <View className="text-center margin-top-15">
                <H3>{messages['app.notification.noNotification']}</H3>
              </View>
            ) : (
              <ListView
                rows={userNotifications.notifications}
                testID="list"
                renderRow={(row) => {
                  return (
                    <ListView.Row key={row.index} markerStyle={rowMarkerStyle}>
                      {this.renderContent(row.item ? row.item : row)}
                    </ListView.Row>
                  )
                }}
              />
            )}
          </View>
        </View>
      </Modal>
    );
  }
}

export default createContainer({
  $queries: {
    screen: {
      height: true,
      width: true,
      isSmall: true,
    },
    notifications: {
      userNotifications: true,
      markedAsRead: { $call: 'markedAsRead' },
      getUserNotifications: { $call: 'getUserNotifications' },
      dataNotification: true,
      isFreshLogin: true,
      fetchMultiSignNotification: { $call: 'fetchMultiSignNotification' },
    },
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    rsaChangePage: { $call: 'rsa.changePage' },
    rsa: { rsaAuthorised: true },
    reports: {
      setOpenDateRangeTab: {
        $set: 'openDateRangeTab',
      },
    },
    auth: {
      isNotificationDisabledForRM: true,
      userId: true
    },
    payments: {
      signingType: true,
      tabSelectedForMultiUser: true,
      setTabSelectedForMultiUser: { $set: 'tabSelectedForMultiUser' },
      multiSignPaymentList: true,
      applyMultiSignFilter: { $call: 'applyMultiSignFilter' },
      getPaymentHistory: { $call: 'getPaymentHistory' },
      setFilterOptions: { $set: 'multiSignFilterOptions' },
    },
    app: {
      user: {
        selectedPortfolioId: true,
        portfoliosData: true,
        setSelectedPortfolioId: {
          $set: 'selectedPortfolioId',
        },
        setSelectedPortfolioData: {
          $set: 'selectedPortfolioData',
        },
      },
    },
    marque: {
      loginDissmiss: true,
    },
  },
})(NotificationModal);
